var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 115,
    viewBox: "0 0 101 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 101,
    height: 115,
    rx: 10,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5002 58.6309C54.2236 58.6309 57.242 55.8034 57.242 52.3155C57.242 48.8275 54.2236 46 50.5002 46C46.7767 46 43.7583 48.8275 43.7583 52.3155C43.7583 55.8034 46.7767 58.6309 50.5002 58.6309Z",
    fill: "#A9A9A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3757 68.1228C53.849 69.0492 48.7801 69.5128 43.6243 68.1228C41.6162 67.5816 40 66.3776 40 64.6497C40 62.906 41.6735 61.8068 43.6754 61.1709C47.8085 59.8573 52.413 59.699 57.3246 61.1709C59.3388 61.7743 61 62.906 61 64.6497C61 66.3776 59.3889 67.594 57.3757 68.1228Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.31be48127bd3f810e29a83a5d0aa5116.svg";
export { ForwardRef as ReactComponent };